import {Injectable} from '@angular/core';
import {Prefix} from '../models/prefix.model';
import {Group} from '../models/group.model';
import {StandardType} from '../models/standard-type.model';
import {ApiConnectService} from './api-connect.service';
import {HttpClient} from '@angular/common/http';
import {StandardTypesService} from './standard-types.service';

const OBSERVE_RESPONSE = 'response';
const MISSING_INDEX = -1;
const ONE_PREFIX = 1;
const EMPTY_NUMBER_PREFIX = '';

@Injectable()
export class PrefixService {
  selectedPrefix: Prefix;
  selectedGroup: Group;
  found = false;
  groupPrefixes: Prefix[] = [];

  customStndNumber: string;

  constructor(private http: HttpClient,
              private apiURL: ApiConnectService,
              private standardTypesService: StandardTypesService) {
  }

  updateTypesList(typeList: StandardType[]) {
    this.standardTypesService.setTypesList(typeList);
  }

  // Получить порядковый номер создаваемого стандарта за день:
  getCountStandardNumber(prefixID: string) {
    return this.http.get(this.apiURL.getCountStandardNum + prefixID, {observe: OBSERVE_RESPONSE as 'response'});
  }

  setGroupPrefixex(prefixes: Prefix[]) {
    this.groupPrefixes = prefixes;
  }

  getGroupPrefixex() {
    return this.groupPrefixes;
  }

  getPrefixesForSelectedGroup() {
    return this.getPrefixesForGroup(this.selectedGroup.id);
  }

  getPrefixesForGroup(groupID: string) {
    return this.http.get<Prefix[]>(this.apiURL.getPrefixesForGroup + groupID, {observe: OBSERVE_RESPONSE as 'response'});
  }

  addNewPrefixToGroup(newPrefixName: string, groups: Group[]) {
    const groupsIDs: Array<Pick<Group, 'id'>> = [];
    for (const g of groups) {
      groupsIDs.push({id: g.id});
    }

    const data = {
      name: newPrefixName,
      prefixGroups: groupsIDs
    };
    return this.http.post(this.apiURL.createPrefixForGroups, data, {observe: OBSERVE_RESPONSE as 'response'});
  }

  isGroupNoSelectNow(newPrefix: Prefix) {
    this.found = true;
    for (const group of newPrefix.prefixGroups) {
      if (this.selectedGroup.id === group.id) {
        this.found = false;
        break;
      }
    }
    return this.found;
  }

  editPrefixInGroup(newPrefix: Prefix) {
    const prefixIndex = this.groupPrefixes.findIndex(item => item.id === newPrefix.id);

    if (!this.isGroupNoSelectNow(newPrefix)) {
      this.groupPrefixes[prefixIndex] = newPrefix;
    } else {
      if (prefixIndex !== MISSING_INDEX) {
        this.groupPrefixes.splice(prefixIndex, ONE_PREFIX);
      }
    }

    const groupsIDs = [];
    for (const group of newPrefix.prefixGroups) {
      groupsIDs.push({id: group.id});
    }

    const data = {
      id: newPrefix.id,
      name: newPrefix.name,
      prefixGroups: groupsIDs
    };
    return this.http.put(this.apiURL.editPrefixForGroups, data, {observe: OBSERVE_RESPONSE as 'response'});
  }

  editPrefixInGroupPre(newPrefix: Prefix) {
    const groupsIDs = [];
    for (const group of newPrefix.prefixGroups) {
      groupsIDs.push({id: group.id});
    }
    const data = {
      id: newPrefix.id,
      name: newPrefix.name,
      prefixGroups: groupsIDs
    };
    return this.http.put(this.apiURL.editPrefixForGroups, data, {observe: OBSERVE_RESPONSE as 'response'});
  }

  getSelectedPrefix() {
    return this.selectedPrefix;
  }

  getNumberPrefix(prefix: Prefix = this.selectedPrefix): string {
    return prefix ? (prefix.numberPrefix || prefix.name) : EMPTY_NUMBER_PREFIX;
  }

  setSelectedPrefix(prefix: Prefix) {
    this.selectedPrefix = prefix;
  }

  setActiveInitiatorGroup(group: Group) {
    this.selectedGroup = group;
  }

  getSelectedGroup() {
    return this.selectedGroup;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/prefix.service.ts